import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { submit, isInvalid, reset } from 'redux-form'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { WithStyles, Theme, createStyles, withStyles, Grid, Paper, Icon, CircularProgress } from '@material-ui/core'
import { RouteComponentProps, withRouter } from 'react-router'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import Page from 'src/shared/Page/Page'
import autobind from 'autobind-decorator'
import Btn from 'src/shared/Btn/Btn'
import KycForm from './KycForm'
import PageTitle from 'src/shared/PageTitle/PageTitle'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import { sendDocument } from 'src/core/redux/action/documentAction'
import PcDialog from 'src/shared/Dialog/PcDialog'
import { colorSuccess } from 'src/shared/style/color'

const styles = (t: Theme) => createStyles({
    root: {
        position: 'relative',
        flexGrow: 1,
        padding: t.spacing.unit * 4,
        backgroundColor: t.palette.background.paper,
    },
});

interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
}

interface IStates {
    isSubmiting: boolean;
    documentToUpload: any;
    modalAlertRedirect: boolean
}


class Kyc extends React.Component<IProps, IStates> {

    state = {
        isSubmiting: false,
        modalAlertRedirect: false,
        documentToUpload: {
            name: null
        },
    }

    render() {
        const {t, isFormValid, classes} = this.props
        const {isSubmiting, documentToUpload} = this.state
        return (
            <>
                <HelmetMeta title={t.App_title_page_kyc}/>
                <PageTitle title={t.App_title_page_kyc} icon="send" />
                
                <Page width="80%">
                    <Paper className={classes.root}>
                        <Grid container>
                            <Grid item xs={12}>
                                <KycForm 
                                    onSubmit={this.handleSubmitDocumentSendForm}
                                    documentToUpload={documentToUpload}
                                    uploadDocument={this.uploadDocument}
                                />
                                <div style={{marginTop: 16, display: 'flex', justifyContent: 'flex-end'}}>
                                <Btn
                                    color='primary'
                                    variant='contained'
                                    loading={isSubmiting}
                                    onClick={this.submitDocumentSendFormRemotely}
                                    disabled={!isFormValid}
                                >{t.send}</Btn>
                                </div>
                            </Grid>
                        </Grid>
                    </Paper>
                    <PcDialog
                        open={this.state.modalAlertRedirect}
                    >
                        <Grid container direction="row" justify="center" alignItems="center" wrap="nowrap">
                            <Icon style={{color: colorSuccess, marginRight: '5px'}}>check_circle</Icon>
                            <span>{t.Document_tunnel_redirect}</span>
                        </Grid>
                        <Grid container direction="row" justify="center">
                            <CircularProgress size={34} />
                        </Grid>
                    </PcDialog>
                </Page>
            </>
        )
    }

    @autobind
    private submitDocumentSendFormRemotely() {
        this.props.submitForm(submit("documentSendForm"))
    };

    @autobind
    private uploadDocument(file) {
        this.setState({documentToUpload: file})
    };

    @autobind
    private handleSubmitDocumentSendForm(values){
        const {t, promisesWithProgress, send} = this.props
        const data = new FormData();
        data.append("file", values.document);
        data.append("name", values.name);
        data.append("category_type", values.categories);
        data.append("must_be_signed", values.must_be_signed)

        this.setState({isSubmiting: true})
        promisesWithProgress(
            send(data).then(res => {
                if(!!values.must_be_signed) {
                    this.setState({modalAlertRedirect: true})
                    setTimeout(() => {
                        this.refeshAfterSubmit()
                        this.setState({modalAlertRedirect: false})
                        window.location.href = res
                    }, 2000);
                } else {
                    this.refeshAfterSubmit(true, t.Document_send_success)
                }
            }).catch(err => {
                this.refeshAfterSubmit(false, err)
            })
        )
    }

    @autobind
    private refeshAfterSubmit(isSuccess?, message?) {
        const {toastSuccess, toastError} = this.props
        this.uploadDocument(null)
        this.props.resetForm()
        this.setState({isSubmiting: false})
        if(isSuccess === true) {
            toastSuccess(message)
        } 
        if(isSuccess === false) {
            toastError(message)
        }
    };

}

const state2props = (state: RootState) => ({
    isFormValid: !isInvalid("documentSendForm")(state),
});

const dispatch2props = (dispatch: any) => ({
    send: (data) => dispatch(sendDocument(data)),
    resetForm: () => dispatch(reset("documentSendForm")),
    submitForm: (handerSubmit) => dispatch(handerSubmit),
});

export default compose(
    withStyles(styles),
    withI18n,
    withRouter,
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(Kyc)



// WEBPACK FOOTER //
// ./src/page/Consumer/Kyc/Kyc.tsx